if (document.querySelector('.homepage-hero-yt')) {
    var windowWidth = document.body.clientWidth,
        ytScriptTag = document.createElement('script'),
        firstScriptTag = document.getElementsByTagName('script')[0],
        ytPlayer,
        ytVideoBgrd = document.querySelector('.homepage-hero-video-container'),
        ytVideoContainer = document.querySelector('.homepage-hero-container'),
        ytVideoWrapper = document.querySelector('.homepage-hero-video'),
        ytLoop = ytVideoWrapper.getAttribute('data-loop') == "true" ? 1 : 0,
        ytVideoControls = document.querySelectorAll('.homepage-hero-controls'),
        ytVideoControlTablet = document.querySelector('.homepage-hero-controls--tablet'),
        ytVideoId = ytVideoWrapper.getAttribute('data-videoid'),
        ytNoVideo = document.querySelector('.homepage-hero-yt--novideo');

    if (!ytNoVideo) {
        //Load YouTube api script
        ytScriptTag.src = "https://www.youtube.com/iframe_api";
        firstScriptTag.parentNode.insertBefore(ytScriptTag, firstScriptTag);

        //Video controls click event
        for (let i = 0; i < ytVideoControls.length; i++) {
            ytVideoControls[i].addEventListener('click', playPause.bind(this));
        }

        window.onYouTubeIframeAPIReady = function () {
            ytPlayer = new YT.Player('heroPlayer', {
                height: '390',
                width: '640',
                host: 'https://www.youtube-nocookie.com',
                videoId: ytVideoId,
                playerVars: {
                    modestbranding: 1,
                    controls: 0,
                    showinfo: 0,
                    enablejsapi: 1,
                    rel: 0,
                    loop: ytLoop,
                    playlist: ytVideoId
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
        }

        function onPlayerReady(event) {
            if (ytVideoControlTablet.style.display !== "none") {
                playVideo();
            }
        }

        function onPlayerStateChange(event) {
            if (ytPlayer.getPlayerState() == 0 && !ytLoop) { //Ended
                buttonPause();
                ytVideoWrapper.classList.remove('homepage-hero-video--show');
            }
        }

        function playVideo() {
            if (!ytPlayer.isMuted()) {
                ytPlayer.mute();
            }
            ytPlayer.playVideo();
            ytVideoWrapper.classList.add('homepage-hero-video--show');
            buttonPlay();
        }

        function pauseVideo() {
            ytPlayer.pauseVideo();
            buttonPause();
        }

        function buttonPlay() {
            for (let i = 0; i < ytVideoControls.length; i++) {
                ytVideoControls[i].classList.remove('homepage-hero-controls--paused');
                ytVideoControls[i].getElementsByTagName('span')[0].innerHTML = 'Pause video';
            }
        }

        function buttonPause() {
            for (let i = 0; i < ytVideoControls.length; i++) {
                ytVideoControls[i].classList.add('homepage-hero-controls--paused');
                ytVideoControls[i].getElementsByTagName('span')[0].innerHTML = 'Play video';
            }
        }

        function playPause() {
            if (windowWidth >= 768 || ytVideoControlTablet.style.display !== "none") {
                switch (ytPlayer.getPlayerState()) {
                    case -1:
                    case 0:
                    case 2:
                    case 5: //unstarted, paused, ended, cued
                        playVideo();
                        break;
                    default:
                        pauseVideo();
                        break;
                }
            }
        }
    }
}
